<template>
  <section class="hero-section">
    <div class="hero-bg">
      <div class="hero-gradient"></div>
    </div>
    <div class="hero-container">
      <div class="hero-content">
        <span class="badge font-label-premium">{{ $t('home.banner.annual_event') || 'Sự kiện thường niên 2026' }}</span>
        <h2 class="hero-title font-title-hero">
          {{ $t('home.banner.title') || 'Hương Vị Đất Sen Hồng Kết Nối & Vươn Xa' }}
        </h2>
        <p class="hero-description font-body-premium">
          {{ $t('home.banner.description') }}
        </p>
        <div class="hero-actions">
          <a href="#lich-hoat-dong" class="btn-primary font-label-premium">
            {{ $t('home.banner.view_schedule') || 'Xem Lịch Sự Kiện' }}
          </a>
          <a href="#san-pham" class="btn-outline font-label-premium">
            {{ $t('home.banner.explore_products') || 'Khám Phá Sản Phẩm' }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style scoped>
/* ======================== RESPONSIVE HERO BANNER ======================== */
.hero-section {
  position: relative;
  width: 100%;
  height: 42.85rem;
  /* ~600px mặc định */
  display: flex;
  align-items: center;
  overflow: hidden;
  background-color: var(--background, #f7fbf0);
}

/* 💻 NÂNG CẤP: Chuyển sang tỉ lệ động trên Desktop để hiển thị trọn vẹn 100% ảnh không bị cắt mép */
@media (min-width: 1024px) {
  .hero-section {
    /* Sử dụng aspect-ratio kết hợp min/max height để banner co giãn tỉ lệ vàng theo chiều ngang */
    aspect-ratio: 16 / 7;
    /* Khớp tuyệt đối với tỉ lệ banner 2560x1080 hoặc 1920x800 */
    height: auto;
    min-height: 500px;
    max-height: 750px;
    /* Khống chế chiều cao tối đa trên màn hình lớn như 27 inch tránh bị quá cao */
  }
}

@media (max-width: 576px) {
  .hero-section {
    height: auto;
    min-height: 42.85rem;
    padding: 4.28rem 0;
    display: flex;
    align-items: center;
  }
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.hero-gradient {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  /* Căn giữa hoàn toàn sau khi đã tối ưu tỷ lệ động */
  transition: background-image 0.5s ease-in-out;

  /* 📱 Viewport Di động (dưới 576px): Sử dụng cờ mobile dọc */
  background-image: linear-gradient(rgba(13, 99, 27, 0.65), rgba(13, 99, 27, 0.35)),
    url("~@/assets/images/banner/mobile_banner.jpg");
}

/* 📟 Viewport Máy tính bảng hoặc màn dọc (Từ 577px đến 1023px) */
@media (min-width: 577px) and (max-width: 1023px) {
  .hero-gradient {
    background-image: linear-gradient(rgba(13, 99, 27, 0.6), rgba(13, 99, 27, 0.25)),
      url("~@/assets/images/banner/portrait_banner.jpg");
    background-position: center center;
  }
}

/* 💻 Viewport Desktop chuẩn, FullHD & 2K màn hình rộng 27" (Từ 1024px trở lên) */
@media (min-width: 1024px) {
  .hero-gradient {
    background-image: linear-gradient(rgba(13, 99, 27, 0.45), rgba(13, 99, 27, 0.15)),
      url("~@/assets/images/banner/desktop_banner.jpg");
    background-position: center center;
    /* Chuyển về center sau khi khung chứa đã responsive tỉ lệ */
  }
}

/* 🖥️ Viewport màn hình siêu rộng Ultra-Wide (Tỷ lệ aspect-ratio >= 21/9) */
@media (min-width: 1600px) and (min-aspect-ratio: 21/9) {
  .hero-gradient {
    background-image: linear-gradient(rgba(13, 99, 27, 0.4), rgba(13, 99, 27, 0.1)),
      url("~@/assets/images/banner/panorama_banner.jpg");
    background-position: center center;
  }
}

.hero-container {
  max-width: var(--container-max, 85.71rem);
  margin: 0 auto;
  padding: 0 var(--spacing-gutter, 1.14rem);
  position: relative;
  z-index: 10;
  width: 100%;
}

.hero-content {
  max-width: 42.85rem;
  /* ~600px */
  color: var(--on-primary, #ffffff);
  text-align: left;
}

@media (max-width: 576px) {
  .hero-content {
    text-align: center;
    margin: 0 auto;
    padding: 2rem 1.42rem;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(3px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border-radius: 1.42rem;
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 0.57rem 2.28rem rgba(0, 0, 0, 0.2);
  }
}

.badge {
  display: inline-block;
  background-color: var(--secondary, #ffb300);
  color: var(--on-secondary, #000000);
  padding: 0.28rem 1.14rem;
  border-radius: var(--rounded-full, 714.28rem);
  font-family: var(--font-body), sans-serif;
  font-size: var(--text-body-sm-size, 0.85rem);
  font-weight: 600;
  margin-bottom: 1.71rem;
}

@media (max-width: 576px) {
  .badge {
    margin-bottom: 1.14rem;
    padding: 0.28rem 0.85rem;
    font-size: 0.78rem;
  }
}

.hero-title {
  color: var(--color-public-surface, #ffffff);
  font-family: var(--font-heading), sans-serif;
  font-size: var(--text-headline-md-size, 2.28rem);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.71rem;
  text-shadow: 0 0.28rem 0.43rem rgba(0, 0, 0, 0.3);
}

@media (min-width: 768px) {
  .hero-title {
    font-size: var(--text-headline-lg-size, 3.42rem);
  }
}

@media (max-width: 576px) {
  .hero-title {
    font-size: 1.71rem !important;
    margin-bottom: 1.14rem;
  }
}

.hero-description {
  font-family: var(--font-body), sans-serif;
  font-size: var(--text-body-lg-size, 1.14rem);
  margin-bottom: 2.28rem;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 0.14rem 0.28rem rgba(0, 0, 0, 0.2);
  line-height: 1.6;
}

@media (max-width: 576px) {
  .hero-description {
    font-size: 0.92rem;
    margin-bottom: 1.71rem;
    line-height: 1.5;
  }
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1.14rem;
}

@media (max-width: 576px) {
  .hero-actions {
    justify-content: center;
    gap: 0.85rem;
    flex-direction: column;
    width: 100%;
  }
}

.btn-primary {
  background-color: var(--secondary, #ffb300);
  color: var(--on-secondary, #000000);
  padding: 0.85rem 2.28rem;
  border-radius: var(--rounded-default, 0.57rem);
  font-family: var(--font-body), sans-serif;
  font-size: var(--text-body-sm-size, 0.85rem);
  font-weight: 600;
  text-decoration: none;
  box-shadow: 0 0.71rem 1.07rem -0.21rem rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, background-color 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-primary:hover {
  transform: scale(1.05);
}

.btn-outline {
  background-color: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: var(--on-primary, #ffffff);
  padding: 0.85rem 2.28rem;
  border-radius: var(--rounded-default, 0.57rem);
  font-family: var(--font-body), sans-serif;
  font-size: var(--text-body-sm-size, 0.85rem);
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.2s, transform 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-outline:hover {
  background-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

@media (max-width: 576px) {

  .btn-primary,
  .btn-outline {
    padding: 0.71rem 1.42rem;
    font-size: 0.85rem;
    width: 100%;
    text-align: center;
    box-sizing: border-box;
  }
}
</style>